import React, { useRef } from "react";
import { Form, Row, Col, Modal, Dropdown } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useState, useEffect } from "react";
import { FetchResourcePoolFilters } from "services/pendingService";
import {
  applyReapplication,
  FetchResourcePoolData,
} from "../../services/onholdService";
import { toast } from "react-toastify";
import {
  checkPermissionStatus,
  generateMaskedPII,
  getCompanyTimezoneDateTime,
} from "helpers/utils";
import Select from "react-select";
import { RangeSlider } from "rsuite";
import { Button, Spinner } from "reactstrap";
import threedots from "../../assets/images/icon/three-dots.svg";
import { MultiSelect } from "react-multi-select-component";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { isEmpty } from "lodash";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import { Link } from "react-router-dom";
import { decryptDataFromArray } from "helpers/EncDec";

import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRemove } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { getCommunicationLogs } from "helpers/backend_helper";
import moment from "moment";
import DataFetchLoader from "components/Common/DataFetchLoader";
import { useTranslation } from "react-i18next";

function ResourcePool(props) {
  const { t } = useTranslation();
  const [dataList, setDataList] = useState([]);
  const [errors, setErrors] = useState("");
  const [filters, setFilters] = useState({});
  const [filterData, setFiltersData] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedJob, setSelectedJob] = useState("");
  const tableRef = useRef(null);
  const history = useHistory();
  const params = new URLSearchParams(window.location.search);

  // Communication Logs changes
  const [communicationLogs, setCommunicationLogs] = useState([]);
  const [candidateDetails, setCandidateDetails] = useState("");
  const [viewModal, setViewModal] = useState(false);
  const [resultData, setResultData] = useState([]);
  const [resultModal, setResultModal] = useState(false);

  const setFilterValues = (payloadObj, filterValues) => {
    let filterObj = {};
    if (payloadObj?.city) {
      let allOptions =
        payloadObj?.city?.split(",")?.map(el => parseInt(el)) || [];
      let selectedOptions = filterValues?.uniqueCities?.filter(el =>
        allOptions?.includes(el?.value)
      );
      filterObj = {
        ...filterObj,
        city: selectedOptions,
      };
    }
    if (payloadObj?.expected_time) {
      let allOptions =
        payloadObj?.expected_time?.split(",")?.map(el => el?.trim()) || [];
      let selectedOptions = filterValues?.jobExpectedTimes?.filter(el =>
        allOptions?.includes(el?.value)
      );
      filterObj = {
        ...filterObj,
        expected_time: selectedOptions,
      };
    }
    if (payloadObj?.experience) {
      filterObj = {
        ...filterObj,
        experience: payloadObj?.experience || "",
      };
    }
    if (payloadObj?.gender) {
      let allOptions =
        payloadObj?.gender?.split(",")?.map(el => el?.trim()) || [];
      let selectedOptions = filterValues?.genderTypes?.filter(el =>
        allOptions?.includes(el?.value)
      );
      filterObj = {
        ...filterObj,
        gender: selectedOptions,
      };
    }
    if (payloadObj?.job_mode) {
      let allOptions =
        payloadObj?.job_mode?.split(",")?.map(el => el?.trim()) || [];
      let selectedOptions = filterValues?.jobModes?.filter(el =>
        allOptions?.includes(el?.value)
      );
      filterObj = {
        ...filterObj,
        job_mode: selectedOptions,
      };
    }
    if (payloadObj?.job_title) {
      let allOptions =
        payloadObj?.job_title?.split(",")?.map(el => parseInt(el)) || [];
      let selectedOptions = filterValues?.jobTitles?.filter(el =>
        allOptions?.includes(el?.value)
      );
      filterObj = {
        ...filterObj,
        job_title: selectedOptions,
      };
    }
    if (payloadObj?.number_of_jobs) {
      let allOptions =
        payloadObj?.number_of_jobs?.split(",")?.map(el => el?.trim()) || [];
      let selectedOptions = filterValues?.jobOpenings?.filter(el =>
        allOptions?.includes(el?.value)
      );
      filterObj = {
        ...filterObj,
        number_of_jobs: selectedOptions,
      };
    }
    if (payloadObj?.qualification) {
      filterObj = {
        ...filterObj,
        qualification: payloadObj?.qualification,
      };
    }
    if (payloadObj?.relevancy_score) {
      let allOptions =
        payloadObj?.relevancy_score?.split(",")?.map(el => parseInt(el)) || [];
      allOptions = allOptions?.length >= 2 ? allOptions?.slice(0, 2) : [0, 100];
      filterObj = {
        ...filterObj,
        relevancy_score: allOptions,
      };
    }
    if (payloadObj?.vacancy_type) {
      let allOptions =
        payloadObj?.vacancy_type?.split(",")?.map(el => parseInt(el)) || [];
      let selectedOptions = filterValues?.vacancyTypes?.filter(el =>
        allOptions?.includes(el?.value)
      );
      filterObj = {
        ...filterObj,
        vacancy_type: selectedOptions,
      };
    }

    if (payloadObj?.application_stage) {
      let allOptions =
        payloadObj?.application_stage?.split(",")?.map(el => el?.trim()) || [];
      let selectedOptions = filterValues?.applicationStages?.filter(el =>
        allOptions?.includes(el?.value)
      );
      filterObj = {
        ...filterObj,
        application_stage: selectedOptions,
      };
    }
    if (payloadObj?.job_portal_name) {
      let allOptions =
        payloadObj?.job_portal_name?.split(",")?.map(el => parseInt(el)) || [];
      let selectedOptions = filterValues?.sourceList?.filter(el =>
        allOptions?.includes(el?.value)
      );
      filterObj = {
        ...filterObj,
        job_portal_name: selectedOptions,
      };
    }
    setFilters(filterObj);
    return filterObj;
  };

  const getApplicationList = async () => {
    setLoading(true);
    let payloadObj = Object.fromEntries(
      new URLSearchParams(window.location.search)
    );
    let filterValues = await getFilterInfo();
    payloadObj = setFilterValues(payloadObj, filterValues);
    if (Object.keys(payloadObj)?.length === 0) {
      setLoading(false);
      return false;
    }
    await FetchResourcePoolData({ filters: payloadObj })
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);
        if (responseData?.status) {
          setDataList(responseData?.data);

          if (responseData?.data?.length) {
            toast.success(t(`Resource Pool.Applications fetched Successfully`));
            toast.success(
              successMessage.slice(0, 1).toUpperCase() +
                successMessage.slice(1).toLowerCase()
            );
            tableRef.current.scrollIntoView();
          } else {
            toast.error(t(`Resource Pool.No Data Available`));
            toast.error(
              errorMessage.slice(0, 1).toUpperCase() +
                errorMessage.slice(1).toLowerCase()
            );
          }
        } else {
          toast.error(t(`Resource Pool.No Data Available`));
          toast.error(
            errorMessage.slice(0, 1).toUpperCase() +
              errorMessage.slice(1).toLowerCase()
          );
        }

        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
        let errMsg =
          err?.response?.data?.message ||
          t(`Resource Pool.Something Went Wrong`);

        // Convert to sentence case
        errMsg = errMsg.charAt(0).toUpperCase() + errMsg.slice(1).toLowerCase();

        toast.error(errMsg);
      });
  };

  useEffect(() => {
    getApplicationList();
    document.title = "NeuroTal - Resource Pool";
  }, []);

  const getFilterInfo = async () => {
    let filterValues = {};
    await FetchResourcePoolFilters()
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);
        let filtersData = responseData?.data || "";
        setFiltersData(filtersData);
        filterValues = filtersData;
      })
      .catch(err => {
        console.log(err);
      });
    return filterValues;
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  const handleCommunicationLogs = async item => {
    await getCommunicationLogs(item?.appl_id)
      .then(res => {
        let responseData = decryptDataFromArray(res);
        setCommunicationLogs(responseData?.data || []);
        setCandidateDetails(item);
        setViewModal(true);
      })
      .catch(err => {
        let errMsg =
          err?.response?.data?.message ||
          t(`Resource Pool.Something Went Wrong`);

        // Convert to sentence case
        errMsg = errMsg.charAt(0).toUpperCase() + errMsg.slice(1).toLowerCase();

        toast.error(errMsg);
      });
  };

  const columns = [
    {
      dataField: "",
      text: "Select",
      classes: "total",
      headerFormatter: (cellContent, row) => {
        return (
          <div key={new Date().getTime()} className="date-tabel">
            <input
              defaultChecked={dataList?.every(el => el?.checked)}
              onClick={e => handleCheckAll(e)}
              type="checkbox"
              title="Select All"
            />
          </div>
        );
      },
      formatter: (cellContent, row) => {
        return (
          <div key={new Date().getTime()} className="date-tabel">
            <input
              defaultChecked={row?.checked || false}
              onClick={e => handleCheck(e, row?.appl_id)}
              type="checkbox"
            />
          </div>
        );
      },
    },
    {
      dataField: "appl_id",
      text: t(`Resource Pool.Application No`),
      classes: "total",
      formatter: (cellContent, row) => {
        const applyDate = new Date(row?.apply_date);
        const formattedDate =
          row?.appl_id +
          "/" +
          (applyDate?.getMonth() + 1) +
          "" +
          applyDate?.getFullYear();
        return (
          <div className="date-tabel">
            <label>{formattedDate}</label>
          </div>
        );
      },
    },
    {
      dataField: "name",
      text: t(`Resource Pool.Name`),
      classes: "application-name ",
      formatter: (cell, row) => (
        <span
          className="clickable-link"
          style={{ cursor: "pointer" }}
          onClick={() => {
            history.push(`/candidate_consolidate/view-details/${row.appl_id}`);
          }}
        >
          {cell}
        </span>
      ),
    },
    {
      dataField: "email_id",
      text: t(`Resource Pool.Email Id`),
      classes: "application-email ",
      formatter: (cell, row) => <>{generateMaskedPII(row?.email_id)}</>,
    },
    {
      dataField: "mobile",
      text: t(`Resource Pool.Mobile No`),
      classes: "application-normal",
      formatter: (cell, row) => <>{generateMaskedPII(row?.mobile, 2)}</>,
    },
    {
      dataField: "job_user.master_reference_table.gender",
      text: t(`Resource Pool.Gender`),
      classes: "application-normal",
    },
    {
      dataField: "master_reference_table.highest_qualification",
      text: t(`Resource Pool.Education`),
      classes: "application-normal education",
    },
    {
      dataField: "job_user.total_experience",
      text: t(`Resource Pool.Total Exp`),
      classes: "application-normal application-step exp",
      headerClasses: "text-center application-step exp",
    },
    {
      dataField: "relevancy_score",
      text: t(`Resource Pool.Relevancy Score`),
      classes: "application-normal application-step",
      headerClasses: "text-center application-step",
    },

    {
      dataField: "vacancy.title",
      text: t(`Resource Pool.Job Role`),
      classes: "application-normal",
    },
    {
      dataField: "master_city.city",
      text: t(`Resource Pool.City`),
      classes: "application-normal",
    },
    {
      dataField: "currentStage",
      text: t(`Resource Pool.Current Stage`),
      classes: "application-normal",
    },
    {
      dataField: "",
      text: t(`Resource Pool.Actions`),
      formatter: (cell, row) => {
        let appl_id = row?.appl_id;
        return (
          <div className="action-application">
            <div className="action-one filter">
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <img src={threedots} alt="" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    disabled={!checkPermissionStatus("resource-pool", "view")}
                    onClick={() => {
                      history.push(
                        `/candidate_consolidate/view-details/${appl_id}`
                      );
                    }}
                  >
                    {t(`Resource Pool.View Details`)}
                  </Dropdown.Item>
                  <Dropdown.Item
                    disabled={!checkPermissionStatus("resource-pool", "view")}
                    onClick={() => {
                      handleCommunicationLogs(row);
                    }}
                  >
                    {t(`Resource Pool.View Communication Logs`)}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        );
      },
    },
  ];

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`Resource Pool.Showing rows`, { from, to, size })}
    </span>
  );
  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  const rowClasses = (row, rowIndex) => {
    let baseClass = rowIndex % 2 === 0 ? "even-row" : "odd-row";

    if (row.id !== undefined && row.id < 10) {
      return `${baseClass} ijuuhsdhsyhsdyhs`;
    }

    return baseClass;
  };

  const hasIdBelow10 = dataList.some(item => item.id < 10);

  const tbodyRef = useRef(null);

  useEffect(() => {
    if (tbodyRef.current) {
      if (dataList.length < 10) {
        tbodyRef.current.style.height = "700px";
      } else {
        tbodyRef.current.style.height = "auto";
      }
    }
  }, [dataList.length]);

 

  const handleSubmit = async () => {
    if (Object.keys(filters)?.length === 0) {
      const errorMessage = t("Resource Pool.Please Select Some filters!");
      toast.error(
        errorMessage.slice(0, 1).toUpperCase() +
          errorMessage.slice(1).toLowerCase()
      );
      return false;
    }
    setLoading(true);
    await FetchResourcePoolData({ filters: filters })
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);

        if (responseData.status) {
          setDataList(responseData?.data);

          if (responseData?.data?.length) {
            const successMessage = t(
              "Resource Pool.Applications fetched Successfully"
            );
            toast.success(
              successMessage.slice(0, 1).toUpperCase() +
                successMessage.slice(1).toLowerCase()
            );
            tableRef.current.scrollIntoView();
          } else {
            const errorMessage = t("Resource Pool.No Data Available");
            toast.error(
              errorMessage.slice(0, 1).toUpperCase() +
                errorMessage.slice(1).toLowerCase()
            );
          }
        } else {
          const errorMessage = t("Resource Pool.No Data Available");
          toast.error(
            errorMessage.slice(0, 1).toUpperCase() +
              errorMessage.slice(1).toLowerCase()
          );
        }

        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
        let errMsg =
          err?.response?.data?.message ||
          t(`Resource Pool.Something Went Wrong`);

        // Convert to sentence case
        errMsg = errMsg.charAt(0).toUpperCase() + errMsg.slice(1).toLowerCase();

        toast.error(errMsg);
      });
  };

  const handleInput = (e, name) => {
    setFilters({
      ...filters,
      [name]: e,
    });
  };


  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const handleCheck = (e, app_id) => {
    let value = e.target.checked;
    let allUsers = dataList?.map(el => {
      if (el?.appl_id === app_id) {
        el.checked = value;
      }
      return el;
    });
    setDataList(allUsers);
  };

  const handleCheckAll = e => {
    let value = e.target.checked;
    let allUsers = dataList?.map(el => {
      el.checked = value;
      return el;
    });
    setDataList(allUsers);
  };

  const handleMultiStatusApply = async () => {
    if (!selectedJob) {
      const errorMessage = t("Resource Pool.Please Select a Job!");
      toast.error(
        errorMessage.slice(0, 1).toUpperCase() +
          errorMessage.slice(1).toLowerCase()
      );
      return;
    }

    setLoading(true);
    Swal.fire({
      title: t(`Resource Pool.Are you sure?`),
      text: t(`Resource Pool.Send Job Recommendation Mail`),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t(`Resource Pool.Submit Details`),
      cancelButtonText: t(`Resource Pool.Cancel`),
    })
      .then(async result => {
        if (result.isConfirmed) {
          let selectedCandidates =
            dataList
              ?.filter(el => el?.checked)
              ?.map(el => parseInt(el?.appl_id)) || [];
          let payload = {
            selectedCandidates: selectedCandidates,
            selectedJob: selectedJob,
          };
          await applyReapplication(payload)
            .then(res => {
              setLoading(false);
              const successMessage = t(
                "Resource Pool.Job Recommendation Mail Sent"
              );
              toast.success(
                successMessage.slice(0, 1).toUpperCase() +
                  successMessage.slice(1).toLowerCase()
              );
              setResultData(res?.data?.resultData || []);
              setResultModal(true);
              handleSubmit();
            })
            .catch(err => {
              let errMsg =
                err?.response?.data?.message ||
                t("Resource Pool.Something Went Wrong");

              // Convert to sentence case
              errMsg =
                errMsg.charAt(0).toUpperCase() + errMsg.slice(1).toLowerCase();

              setLoading(false);
              toast.error(errMsg);
            });
        }
      })
      .catch(error => {
        let errMsg =
          error?.response?.data?.message ||
          error?.message ||
          t(`Resource Pool.Something Went Wrong`);

        // Convert to sentence case
        errMsg = errMsg.charAt(0).toUpperCase() + errMsg.slice(1).toLowerCase();

        toast.error(errMsg);
      });
  };
   if (!checkPermissionStatus("job-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`job-list.Access Denied`)}</h4>
      </div>
    );
  }

  if (!checkPermissionStatus("resource-pool", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`Resource Pool.Access Denied`)}</h4>
      </div>
    );
  }

  return (
    <>
      <div className="page-content departmentpage">
        <div className="joblist-container create-vacancy">
          <Row className="mb-1 align-items-center">
            <Col lg="6" md="6" className="Joblist-column">
              <Link to="/dashboard">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  {t(`Resource Pool.Find Candidates`)}
                </h5>
              </Link>
            </Col>
          </Row>
        </div>
        <DataFetchLoader loading={loading} />
        <div className="pending-list-page">
          <div className="outerTab-box-wrapper below-vacancy pt-1">
            {/* <h2 className="mt-3 ">Find Candidates</h2> */}
            <p className="pt-2 select-clas">
              {t(`Resource Pool.Select Filters`)}
            </p>
            <div className="tab-content mt-3" id="pills-tabContent">
              <div className="form-details-section">
                <Row>
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3 floating-label">
                      <Form.Label className="float-label">
                        {t(`Resource Pool.Job Title / Designation`)}
                      </Form.Label>
                      <div
                        title={
                          (filters?.job_title || [])
                            .map(item => item.label)
                            .join(", ") ||
                          `${t(`Resource Pool.Job Title / Designation`)}`
                        }
                      >
                        <MultiSelect
                          id="job_title"
                          placeholder={t(
                            `Resource Pool.Select Job Title / Designation`
                          )}
                          name="job_title"
                          value={filters?.job_title || []}
                          // isMulti
                          options={filterData?.jobTitles || []}
                          onChange={e => handleInput(e, "job_title")}
                          title={filters?.job_title || []}
                          overrideStrings={{
                            selectSomeItems: t(
                              `Resource Pool.Select Job Title / Designation`
                            ),
                            allItemsAreSelected: t(
                              "Resource Pool.All items are selected"
                            ),
                            search: t("Resource Pool.Search"),
                            selectAll: t("Resource Pool.Select All"),
                          }}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3 floating-label">
                      <Form.Label
                        className="float-label"
                        title="Select the current stage of the application"
                      >
                        {t(`Resource Pool.Application Stage`)}
                      </Form.Label>

                      <div
                        title={
                          (filters?.application_stage || [])
                            .map(item => item.label)
                            .join(", ") ||
                          `${t(`Resource Pool.Application Stage`)}`
                        }
                      >
                        <MultiSelect
                          id="product_status"
                          placeholder={t(
                            `Resource Pool.Select Application Stage`
                          )}
                          name="application_stage"
                          value={filters?.application_stage || []}
                          // isMulti
                          options={filterData?.applicationStages || []}
                          onChange={e => handleInput(e, "application_stage")}
                          // title={filters?.application_stage || []}
                          overrideStrings={{
                            selectSomeItems: t(
                              `Resource Pool.Select Application Stage`
                            ),
                            allItemsAreSelected: t(
                              "Resource Pool.All items are selected"
                            ),
                            search: t("Resource Pool.Search"),
                            selectAll: t("Resource Pool.Select All"),
                          }}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3 floating-label">
                      <Form.Label className="float-label">
                        {t(`Resource Pool.Vacancy Type`)}
                      </Form.Label>

                      <div
                        title={
                          (filters?.vacancy_type || [])
                            .map(item => item.label)
                            .join(", ") || `${t(`Resource Pool.Vacancy Type`)}`
                        }
                      >
                        <MultiSelect
                          id="product_status"
                          placeholder="Select Position Level"
                          name="vacancy_type"
                          value={filters?.vacancy_type || []}
                          // isMulti
                          options={filterData?.vacancyTypes || []}
                          onChange={e => handleInput(e, "vacancy_type")}
                          overrideStrings={{
                            selectSomeItems: t(
                              `Resource Pool.Select Vacancy Type`
                            ),
                            allItemsAreSelected: t(
                              "Resource Pool.All items are selected"
                            ),
                            search: t("Resource Pool.Search"),
                            selectAll: t("Resource Pool.Select All"),
                          }}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3 floating-label">
                      <Form.Label className="float-label">
                        {t(`Resource Pool.City`)}
                      </Form.Label>

                      <div
                        title={
                          (filters?.city || [])
                            .map(item => item.label)
                            .join(", ") || `${t(`Resource Pool.City`)}`
                        }
                      >
                        <MultiSelect
                          id="city"
                          placeholder={t(`Resource Pool.Select City`)}
                          name="city"
                          value={filters?.city || []}
                          // isMulti
                          options={filterData?.uniqueCities || []}
                          onChange={e => handleInput(e, "city")}
                          overrideStrings={{
                            selectSomeItems: t(`Resource Pool.Select City`),
                            allItemsAreSelected: t(
                              "Resource Pool.All items are selected"
                            ),
                            search: t("Resource Pool.Search"),
                            selectAll: t("Resource Pool.Select All"),
                          }}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3 floating-label">
                      <Form.Label className="float-label">
                        {t(`Resource Pool.Gender`)}
                      </Form.Label>

                      <div
                        title={
                          (filters?.gender || [])
                            .map(item => item.label)
                            .join(", ") || `${t(`Resource Pool.Gender`)}`
                        }
                      >
                        <MultiSelect
                          id="gender"
                          placeholder={t(`Resource Pool.Select Gender`)}
                          name="gender"
                          value={filters?.gender || []}
                          // isMulti
                          options={filterData?.genderTypes || []}
                          onChange={e => handleInput(e, "gender")}
                          overrideStrings={{
                            selectSomeItems: t(`Resource Pool.Select Gender`),
                            allItemsAreSelected: t(
                              "Resource Pool.All items are selected"
                            ),
                            search: t("Resource Pool.Search"),
                            selectAll: t("Resource Pool.Select All"),
                          }}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3 floating-label">
                      <Form.Label className="float-label">
                        {t(`Resource Pool.Skills`)}
                      </Form.Label>

                      <div
                        title={
                          (filters?.skills || [])
                            .map(item => item.label)
                            .join(", ") || `${t(`Resource Pool.Skills`)}`
                        }
                      >
                        <MultiSelect
                          id="skills"
                          placeholder={t(`Resource Pool.Select Skills`)}
                          name="skills"
                          value={filters?.skills || []}
                          // isMulti
                          options={filterData?.skillList || []}
                          onChange={e => handleInput(e, "skills")}
                          overrideStrings={{
                            selectSomeItems: t(`Resource Pool.Select Skills`),
                            allItemsAreSelected: t(
                              "Resource Pool.All items are selected"
                            ),
                            search: t("Resource Pool.Search"),
                            selectAll: t("Resource Pool.Select All"),
                          }}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3 floating-label">
                      <Form.Label className="float-label">
                        {t(`Resource Pool.Hiring Source`)}
                      </Form.Label>

                      <div
                        title={
                          (filters?.job_portal_name || [])
                            .map(item => item.label)
                            .join(", ") || `${t(`Resource Pool.Hiring Source`)}`
                        }
                      >
                        <MultiSelect
                          id="job_portal_name"
                          placeholder={t(`Resource Pool.Select Hiring Source`)}
                          name="job_portal_name"
                          value={filters?.job_portal_name || []}
                          // isMulti
                          options={filterData?.sourceList || []}
                          onChange={e => handleInput(e, "job_portal_name")}
                          overrideStrings={{
                            selectSomeItems: t(
                              `Resource Pool.Select Hiring Source`
                            ),
                            allItemsAreSelected: t(
                              "Resource Pool.All items are selected"
                            ),
                            search: t("Resource Pool.Search"),
                            selectAll: t("Resource Pool.Select All"),
                          }}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3 floating-label">
                      <Form.Label className="float-label">
                        {t(`Resource Pool.Mode of Job`)}
                      </Form.Label>

                      <div
                        title={
                          (filters?.job_mode || [])
                            .map(item => item.label)
                            .join(", ") || `${t(`Resource Pool.Mode of Job`)}`
                        }
                      >
                        <MultiSelect
                          id="job_mode"
                          placeholder={t(`Resource Pool.Select Mode of Job`)}
                          name="job_mode"
                          value={filters?.job_mode || []}
                          // isMulti
                          options={filterData?.jobModes || []}
                          onChange={e => handleInput(e, "job_mode")}
                          overrideStrings={{
                            selectSomeItems: t(
                              `Resource Pool.Select Mode of Job`
                            ),
                            allItemsAreSelected: t(
                              "Resource Pool.All items are selected"
                            ),
                            search: t("Resource Pool.Search"),
                            selectAll: t("Resource Pool.Select All"),
                          }}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3 floating-label">
                      <Form.Label className="float-label">
                        {t(`Resource Pool.Number of Jobs`)}
                      </Form.Label>

                      <div
                        title={
                          (filters?.number_of_jobs || [])
                            .map(item => item.label)
                            .join(", ") ||
                          `${t(`Resource Pool.Number of Jobs`)}`
                        }
                      >
                        <MultiSelect
                          id="number_of_jobs"
                          placeholder={t(`Resource Pool.Select Number of Jobs`)}
                          name="number_of_jobs"
                          value={filters?.number_of_jobs || []}
                          // isMulti
                          options={filterData?.jobOpenings || []}
                          onChange={e => handleInput(e, "number_of_jobs")}
                          overrideStrings={{
                            selectSomeItems: t(
                              `Resource Pool.Select Number of Jobs`
                            ),
                            allItemsAreSelected: t(
                              "Resource Pool.All items are selected"
                            ),
                            search: t("Resource Pool.Search"),
                            selectAll: t("Resource Pool.Select All"),
                          }}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3 floating-label">
                      <Form.Label className="float-label">
                        {t(`Resource Pool.Required Qualifications`)}
                      </Form.Label>
                      <Form.Control
                        placeholder={t(
                          `Resource Pool.Select Required Qualifications`
                        )}
                        type="text"
                        name="qualification"
                        value={filters?.qualification || []}
                        onChange={e =>
                          handleInput(e.target.value, "qualification")
                        }
                        title={`Please enter ${t(
                          `Resource Pool.Required Qualifications`
                        ).toLowerCase()}`}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3 floating-label">
                      <Form.Label className="float-label">
                        {t(`Resource Pool.Required Experience`)}
                      </Form.Label>
                      <Form.Control
                        placeholder={t(
                          `Resource Pool.Select Required Experience`
                        )}
                        type="text"
                        name="experience"
                        value={filters?.experience || []}
                        onChange={e =>
                          handleInput(e.target.value, "experience")
                        }
                        title={`Please enter ${t(
                          `Resource Pool.Required Experience`
                        ).toLowerCase()}`}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3 floating-label">
                      <Form.Label className="float-label">
                        {t(`Resource Pool.Required Expected Time`)}
                      </Form.Label>

                      <div
                        title={
                          (filters?.expected_time || [])
                            .map(item => item.label)
                            .join(", ") ||
                          `${t(`Resource Pool.Required Expected Time`)}`
                        }
                      >
                        <MultiSelect
                          id="expected_time"
                          placeholder={t(
                            `Resource Pool.Select Required Expected Time`
                          )}
                          name="expected_time"
                          value={filters?.expected_time || []}
                          // isMulti
                          options={filterData?.jobExpectedTimes || []}
                          onChange={e => handleInput(e, "expected_time")}
                          overrideStrings={{
                            selectSomeItems: t(
                              `Resource Pool.Select Required Expected Time`
                            ),
                            allItemsAreSelected: t(
                              "Resource Pool.All items are selected"
                            ),
                            search: t("Resource Pool.Search"),
                            selectAll: t("Resource Pool.Select All"),
                          }}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3 floating-label">
                      <Form.Label
                        className="float-label"
                        htmlFor="relevancy-score-slider"
                      >
                        {t(`Resource Pool.Relevancy Score`)}
                      </Form.Label>
                      <RangeSlider
                        id="relevancy-score-slider"
                        progress
                        min={0}
                        max={100}
                        className="dual-range mt-3"
                        value={filters?.relevancy_score || []}
                        onChange={value => {
                          handleInput(value, "relevancy_score");
                        }}
                        title={`Please enter ${t(
                          `Resource Pool.Relevancy Score`
                        ).toLowerCase()}`}
                      />
                      <div className="d-flex justify-content-between mt-1">
                        <div className="mx-1">0</div>
                        <div className="mx-1">100</div>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <div className="cta text-center d-flex justify-content-start gap-3 mt-4 pb-3">
                    <Link
                      to="/dashboard"
                      className="btn btn-secondary"
                      aria-label={t("Resource Pool.Cancel")}
                    >
                      {t(`Resource Pool.Cancel`)}
                    </Link>
                    <button
                      className="btn btn-primary"
                      onClick={() => handleSubmit()}
                      aria-label={t("Resource Pool.Search Candidates")} // Add aria-label for accessibility
                    >
                      {t(`Resource Pool.Search Candidates`)}
                    </button>
                  </div>
                </Row>
              </div>
              <div
                className="tab-pane fade show active  spece-low-cum  mt-5"
                id="pills-home"
                role="tabpanel"
                // aria-labelledby="pills-home-tab"
              >
                <div className="tabel-application table-responsive pb-3">
                  <div className="table-data-search mb-3">
                    <div className="total-record">
                      <h5>
                        {t(`Resource Pool.Total Records`)}:{" "}
                        <span>{dataList?.length || 0}</span>
                      </h5>
                    </div>

                    <div className="total-serachbar  right-arrow-li resoursepoll">
                      <div className="tale-text right-panel position-relative">
                        <button
                          className="button left"
                          onClick={() => handleScroll("left")}
                          data-tooltip={t(`Resource Pool.Scroll Left`)}
                        >
                          <img src={right_arrow} alt="right-arrow" />
                        </button>
                        <button
                          className="button right"
                          onClick={() => handleScroll("right")}
                          data-tooltip={t(`Resource Pool.Scroll Right`)}
                        >
                          <img src={right_arrow} alt="right-arrow" />
                        </button>
                      </div>
                    </div>
                  </div>

                  {dataList?.filter(el => el?.checked)?.length > 0 && (
                    <div className="jobposting-card mb-4">
                      <>
                        <div className="job-post-minicard jobcard w-100 d-flex justify-content-between flex-row align-items-center">
                          <div className="jov-fonts ob">
                            <FontAwesomeIcon
                              // onClick={() => setSelectedCandidates([])}
                              icon={faRemove}
                              className="font-size-20"
                              style={{ cursor: "pointer" }}
                            />{" "}
                            <span className="mx-3 font-size-20">
                              {" "}
                              {dataList?.filter(el => el?.checked)?.length ||
                                0}{" "}
                              {t(`Resource Pool.Selected`)}
                            </span>
                          </div>
                          <div className="d-flex gap-3 jov-fonts">
                            <div className="select-class-job">
                              <Select
                                placeholder={t(`Resource Pool.Select Position`)}
                                options={filterData?.jobTitles}
                                onChange={e => setSelectedJob(e.value)}
                                value={filterData?.jobTitles?.find(
                                  el => el?.value === selectedJob
                                )}
                              />
                            </div>
                            <Button onClick={() => handleMultiStatusApply()}>
                              {t(`Resource Pool.Job Invite`)}
                            </Button>
                          </div>
                        </div>
                      </>
                    </div>
                  )}

                  <div ref={tableRef} className="timeto-hire-card userlist">
                    <div className="table-custome-class range-custome">
                      {dataList && dataList?.length > 0 ? (
                        <div
                          key={new Date().getTime()}
                          className="scroll-container"
                        >
                          <div className="table-wrapper" ref={tableWrapperRef}>
                            <BootstrapTable
                              keyField="id"
                              data={dataList}
                              columns={columns}
                              pagination={paginationFactory(options)}
                              rowClasses={rowClasses}
                              hover
                              responsive
                              wrapperClasses="table-wrapper"
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="table-wrapper" ref={tableWrapperRef}>
                          <div className="no-data data-available">
                            <img
                              src="../img/data-not-available.png"
                              alt="data not availble"
                            />
                            <h3>{t(`Resource Pool.No Item Found`)}</h3>
                            <p>{t(`Resource Pool.Modify Filters`)}</p>
                          </div>
                          {/* <table className="table table-hover table-bordered tsb">
                            <thead>
                              <tr>
                                <th>{t(`Resource Pool.Application No`)}</th>
                                <th>{t(`Resource Pool.Email Id`)}</th>
                                <th>{t(`Resource Pool.Mobile No`)}</th>
                                <th>{t(`Resource Pool.Gender`)}</th>
                                <th>{t(`Resource Pool.Education`)}</th>
                                <th>{t(`Resource Pool.Total Exp`)}</th>
                                <th>{t(`Resource Pool.Relevancy Score`)}</th>
                                <th>{t(`Resource Pool.Job Role`)}</th>
                                <th>{t(`Resource Pool.City`)}</th>
                                <th>{t(`Resource Pool.Current Stage`)}</th>
                                <th>{t(`Resource Pool.Actions`)}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td colSpan="12" className="text-center">
                                  
                                </td>
                              </tr>
                            </tbody>
                          </table> */}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          size="lg"
          show={viewModal}
          onHide={() => {
            setViewModal(false);
            setCandidateDetails("");
          }}
          className="edit-modal-card userdetailsmodal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {t(`Resource Pool.Communication Logs`)} -{" "}
              {candidateDetails?.name || ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mt-3">
              <table className="table table-bordered table-responisve">
                <thead>
                  <tr>
                    <th className="text-left appl-no">
                      {t(`Resource Pool.Serial No`)}
                    </th>
                    <th className="text-center">
                      {t(`Resource Pool.Description`)}
                    </th>
                    <th className="text-center">
                      {t(`Resource Pool.Position`)}
                    </th>
                    <th className="text-left">{t(`Resource Pool.Medium`)}</th>
                    <th className="text-center">{t(`Resource Pool.Date`)}</th>
                    <th className="text-center">{t(`Resource Pool.Status`)}</th>
                  </tr>
                </thead>
                <tbody>
                  {communicationLogs?.map((el, index) => {
                    return (
                      <tr key={index}>
                        <td className="text-left appl-no">{index + 1}</td>
                        <td className="text-center">{el?.action}</td>
                        <td className="text-left">
                          {el?.vacancy?.title || ""}
                        </td>
                        <td className="text-left">{el?.type}</td>
                        <td className="text-left">
                          {el?.createdAt
                            ? moment(
                                getCompanyTimezoneDateTime(el?.createdAt)
                              ).format("Do MMM'YY, hh:mm a")
                            : ""}
                        </td>
                        <td className="text-center">
                          {el?.status === "Success" ? (
                            <span className="text-success">
                              {t(`Resource Pool.Success`)}
                            </span>
                          ) : (
                            <span className="text-danger">
                              {t(`Resource Pool.Failure`)}
                            </span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                  {communicationLogs?.length === 0 && (
                    <p className="text-center m-2 p-2">
                      {t(`Resource Pool.No Data Available`)}
                    </p>
                  )}
                </tbody>
              </table>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          size="lg"
          show={resultModal}
          onHide={() => {
            setResultModal(false);
            setResultData([]);
          }}
          className="edit-modal-card asseentModal  import-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {t(`Resource Pool.Action Summary`)} -{" "}
              {filterData?.jobTitles?.find(el => el?.value === selectedJob)
                ?.label || ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <table className="table table-bordered table-responisve">
                <thead>
                  <tr>
                    <th className="text-center">
                      {t(`Resource Pool.Serial No`)}
                    </th>
                    <th className="text-center">{t(`Resource Pool.Name`)}</th>
                    <th className="text-left">{t(`Resource Pool.Email Id`)}</th>
                    <th className="text-center">{t(`Resource Pool.Status`)}</th>
                  </tr>
                </thead>
                <tbody>
                  {resultData?.map((el, index) => {
                    return (
                      <tr key={index}>
                        <td className="text-center">{index + 1}</td>
                        <td className="text-center">{el?.name}</td>
                        <td className="text-left">{el?.email_id}</td>
                        <td className="text-center">
                          {el?.success ? (
                            <span className="text-success">
                              {t(`Resource Pool.Mail Sent Successfully`)}
                            </span>
                          ) : (
                            <span className="text-danger">
                              {t(`Resource Pool.Sending Email Unsuccessful`)}
                              <br /> [{el?.reason}]
                            </span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default ResourcePool;
